import React from 'react';

import { formatDiffValue, getPathLabel } from '../client-diff';
import { useFeaturesCatalog } from '../feature-catalog';

const TYPE_LABELS = {
  added: 'Ajouté',
  removed: 'Supprimé',
  changed: 'Modifié',
};

/**
 * Différences champ par champ entre deux versions de la configuration du
 * client : libellé lisible, avant (rouge), après (vert).
 */
export default function ClientChangesDiff({ diff, stripRoot = false }) {
  const catalog = useFeaturesCatalog();

  if (!diff.length) {
    return (
      <p className="tw-m-0 tw-text-sm tw-text-text-dark-medium-importance">
        Aucune différence.
      </p>
    );
  }

  return (
    <div className="tw-overflow-auto tw-rounded-md tw-border tw-border-solid tw-border-black/10">
      <table className="tw-w-full tw-border-collapse tw-text-xs">
        <thead>
          <tr className="tw-bg-[#F7F8FA] tw-text-left tw-text-text-dark-medium-importance">
            <th className="tw-px-2 tw-py-1 tw-font-semibold">Champ</th>
            <th className="tw-px-2 tw-py-1 tw-font-semibold">Avant</th>
            <th className="tw-px-2 tw-py-1 tw-font-semibold">Après</th>
          </tr>
        </thead>
        <tbody>
          {diff.map((change) => (
            <tr
              key={change.path}
              className="tw-border-0 tw-border-t tw-border-solid tw-border-black/5 tw-align-top"
            >
              <td className="tw-break-words tw-px-2 tw-py-1">
                {getPathLabel(change.path, catalog, { stripRoot })}
                <span className="tw-block tw-font-mono tw-text-[10px] tw-text-text-dark-medium-importance">
                  {change.path}
                </span>
                <span className="tw-sr-only">
                  {' '}
                  ({TYPE_LABELS[change.type]})
                </span>
              </td>
              <td className="tw-break-all tw-bg-status-negative/5 tw-px-2 tw-py-1 tw-font-mono tw-text-status-negative">
                {change.type === 'added' ? '—' : formatDiffValue(change.before)}
              </td>
              <td className="tw-break-all tw-bg-status-positive/5 tw-px-2 tw-py-1 tw-font-mono tw-text-[#0B7A5C]">
                {change.type === 'removed'
                  ? '—'
                  : formatDiffValue(change.after)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
